export default __webpack_public_path__ + "static/media/add-to-contact.bd0cf117.svg";